

import moment from "moment";
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import ReactToPrint from 'react-to-print';
import count_days from "../../../functions/count_days";
import sum_amount from "../../../functions/sum_total_amount";
import sum_amount_by_payment_type from "../../../functions/sum_total_amount_by_payment_type";
import { _endPoints, getallusers, getpaymentsdate, getpaymenttype, getbankaccounts } from "../../../Helper/links";
import API from "../../../Helper/server/API";
import empty from '../../../public/svg/empty.svg';
import { InvoiceContext } from './invoices/Invoice_Context';
import InvoicePaymentsDates from "./invoices/invoice_payments_dates";
import view_apartment_type_ar from "../../../functions/data_view";
function PaymentsViaBankTransfers() {
    const toast = useRef(null);
    const componentRef = useRef();
    const buttonRef = useRef();
    const [isShown, setIsShown] = useState(false);
    const items = Array.from({ length: 5 }, (v, i) => i);
    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });
    const [loading_users, set_loading_users] = useState(false);
    const [loading_apartment, set_loading_apartment] = useState(false);
    const [loading_service, set_loading_service] = useState(false);
    const [loading_bank_accounts, set_loading_bank_accounts] = useState(false);
    //____________________________________________________________
    const [loading_report_day, set_loading_report_day] = useState(false);
    //____________________________________________________________
    const [apartments, setApartments] = useState([]);
    const [apartments_view, setApartments_view] = useState([]);

    const [services, setServices] = useState([]);
    const [services_view, setServices_view] = useState([]);
    const [payment_types_view, set_payment_types_view] = useState([]);

    const [bank_accounts, set_bank_accounts] = useState([]);
    const [bank_accounts_view, set_bank_accounts_view] = useState([]);

    const [users, set_users] = useState([]);
    const [users_view, set_users_view] = useState([]);
    const [payment_by_customer, set_psyment_by_customer] = useState(true);
    const [booking_filter, set_booking_filter] = useState(['دفع مسبق', 'دفع عند الاستلام']);
    //____________________________________________________________
    //____________________________________________________________

    const [selectedpayments, setSelectedpayments] = useState([]);
    const [date_from, set_date_from] = useState(new Date());
    const [date_to, set_date_to] = useState(new Date());
    const [PrintInvoicePayments_Day, setPrintInvoicePayments_Day] = useState(false);
    //_______________________________________________________________________________________
    //                      Get Reservationes
    const GetApartment = async () => {
        set_loading_apartment(true);
        const response = await API.get(_endPoints.apartments.get_apartments)
        if (response?.success === 1) {
            setApartments(response.data);
            setApartments_view(response.data);
        }
        set_loading_apartment(false);
    }

    const GetServices = async () => {
        set_loading_service(true);
        const response = await API.get(_endPoints.reservations.services.get_all)
        if (response?.success === 1) {
            setServices(response.data);
            setServices_view(response.data);
        }
        set_loading_service(false);
    }

    const GetBankAccounts = async () => {
        set_loading_bank_accounts(true);
        try {
            const response = await API.get(getbankaccounts);
            if (response?.success === 1 && Array.isArray(response?.data)) {
                set_bank_accounts(response.data);
                set_bank_accounts_view(response.data);
            }
        } catch (err) {
            console.error(err);
        }
        set_loading_bank_accounts(false);
    };

    const [loading_get_payment_type, set_loading_get_payment_type] = useState(true)
    const [payment_types, set_payment_types] = useState([])

    const GetPaymentType = async () => {
        set_loading_get_payment_type(true);
        const response = await API.get(`${getpaymenttype}`)
        if (response?.success === 1) {
            set_payment_types(response.data);
            const bankType = response.data.filter(pt => pt.id_payment_type === 5);
            set_payment_types_view(bankType.length > 0 ? bankType : response.data);
        }
        set_loading_get_payment_type(false);
    }
    const GetUsers = async () => {
        set_loading_users(true);
        const response = await API.get(getallusers)
        if (response?.success === 1) {
            set_users(response.users);
        }
        set_loading_users(false);
    }
    const [_payments_day, set_Payments_day] = useState([]);

    const filtered_payments = React.useMemo(() => {
        let payments = _payments_day?.payments || [];

        if (bank_accounts_view && bank_accounts_view.length > 0 && bank_accounts.length > 0) {
            const selectedAccs = bank_accounts_view.map(b => typeof b === 'string' ? b : b.value_key_2);
            payments = payments.filter(item => item.value_key_2 && selectedAccs.includes(item.value_key_2));
        }

        if (!booking_filter || booking_filter.length === 0 || booking_filter.length === 2) {
            return payments;
        }
        return payments.filter(item => {
            const isSameDay = item?.date_payment && item?.date_check_in && moment(item.date_payment).format('YYYY-MM-DD') === item.date_check_in;
            if (booking_filter.includes('دفع مسبق')) {
                return !isSameDay;
            }
            if (booking_filter.includes('دفع عند الاستلام')) {
                return isSameDay;
            }
            return true;
        });
    }, [_payments_day, booking_filter, bank_accounts_view, bank_accounts]);

    const filtered_payment_types = React.useMemo(() => {
        if (!_payments_day?.payment_types) return [];
        const baseTypes = _payments_day.payment_types.filter(pt => pt.id_payment_type !== undefined && pt.name_payment_type !== 'إجمـــالي المبلـــغ');
        let grandTotal = 0;
        const updatedTypes = baseTypes.map(pt => {
            const total = filtered_payments.reduce((sum, item) => {
                if (item.id_payment_type === pt.id_payment_type) {
                    return sum + (item.amount || 0);
                }
                return sum;
            }, 0);
            grandTotal += total;
            return {
                ...pt,
                total_amount: total
            };
        });
        updatedTypes.push({
            name_payment_type: 'إجمـــالي المبلـــغ',
            total_amount: grandTotal
        });
        return updatedTypes;
    }, [_payments_day, filtered_payments]);

    const filtered_data = React.useMemo(() => {
        return {
            payments: filtered_payments,
            payment_types: filtered_payment_types
        };
    }, [filtered_payments, filtered_payment_types]);

    const GetPaymentsDay = async () => {
        set_loading_report_day(true);
        var users = [];
        var apartments = [];
        var services = [];
        var payment_type = [];

        // eslint-disable-next-line array-callback-return
        users_view.map(item => {
            if (item.ID_user) {
                users.push(item.ID_user);
            }
        })
        // eslint-disable-next-line array-callback-return
        apartments_view.map(item => {
            if (item.ID_apartment) {
                apartments.push(item.ID_apartment);
            }
        })
        // eslint-disable-next-line array-callback-return
        services_view.map(item => {
            if (item.ID_service) {
                services.push(item.ID_service);
            }
        })
        var data = {
            date: moment(date_from).format("yyyy-MM-DD"),
            date_from: moment(date_from).format("yyyy-MM-DD"),
            date_to: moment(date_to).format("yyyy-MM-DD"),
            users: users,
            services: services,
            apartments: apartments,
            payment_types: [5],
            payment_by_customer: true
        }
        const response = await API.post(getpaymentsdate, data);
        if (response?.success === 1) {
            set_Payments_day(response?.data)
            if (response?.data?.payments && Array.isArray(response?.data?.payments)) {
                const accountsInPayments = Array.from(
                    new Set(
                        response.data.payments
                            .map(p => p.value_key_2)
                            .filter(val => val && String(val).trim() !== '')
                    )
                ).map(val => ({ value_key_2: val }));
                if (accountsInPayments.length > 0) {
                    set_bank_accounts(prev => {
                        if (prev.length === 0) {
                            set_bank_accounts_view(accountsInPayments);
                            return accountsInPayments;
                        }
                        return prev;
                    });
                }
            }
        }
        else if (response?.success === 0) {
            toast?.current?.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response.msg
            });
        }
        set_loading_report_day(false);
    }
    const ApartmentsViewItemTemplate = (apt) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl", paddingRight: ".5rem" }} >
                <span>{view_apartment_type_ar(apt.type)} - {apt.number}</span>
            </div>
        );
    };
    const ServicesViewItemTemplate = (srv) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl", paddingRight: ".5rem" }} >
                <span>{srv.service_name_ar}</span>
            </div>
        );
    };
    const BankAccountsViewItemTemplate = (acc) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl", paddingRight: ".5rem" }} >
                <span>{typeof acc === 'string' ? acc : acc.value_key_2}</span>
            </div>
        );
    };
    const UsersViewItemTemplate = (user) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl", paddingRight: ".5rem" }} >
                <span>{user.name}</span>
            </div>
        );
    };
    const PaymtenTypeViewItemTemplate = (item) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl", paddingRight: ".5rem" }} >
                <span>{item.name_payment_type}</span>
            </div>
        );
    };
    //____________________________________________________________
    const View_Date = (data) => {
        return (
            <strong >
                {moment(data.date_payment).format('yyyy-MM-DD')}
                <br></br>
                {moment(data.date_payment).format('hh:mm A')}
            </strong>
        )
    }
    const View_total_price = (data) => {
        return (
            <strong >
                {Intl.NumberFormat("en-US").format(data.total_price)} د،ل
            </strong>
        )
    }
    const View_Amount = (data) => {
        if (data.amount < 0) {
            return (
                <strong style={{ color: "red" }}>
                    {Intl.NumberFormat("en-US").format(data.amount)} د.ل
                </strong>
            )
        }
        else {
            return (
                <strong style={{ color: "green" }}>
                    {Intl.NumberFormat("en-US").format(data.amount)} د.ل
                </strong>
            )
        }
    }
    const View_payment_type = (item) => {
        return (
            <>
                <strong >
                    {item.name_payment_type}
                </strong>

                {
                    item?.value_key ?
                        <><br></br>{item?.value_key}</> : null
                }
                {
                    item?.value_key_2 ?
                        <><br></br>{item?.value_key_2}</> : null
                }

            </>
        )
    }
    const View_Days = (data) => {
        return (
            <strong >
                {count_days([data])}
            </strong>
        )
    }
    const view_number_people = (data) => {
        return (
            <strong >
                {data?.number_people ? <>{data?.number_people}<i className="pi pi-users mr-1 ml-1"></i></> : null}
            </strong>
        )
    }
    const view_Apartment = (data) => {
        return (
            <strong >
                {
                    data?.reservation_type === 'service' ?
                        <span> {data?.service_name_ar ?? '-'}</span> :
                        <span>{view_apartment_type_ar(data.type)} - {data.number}</span>
                }
            </strong>
        )
    }
    const state_res = (data) => {
        if (data.del === 1) {
            return (
                <strong style={{ color: "red" }}>
                    ملغي
                </strong>
            )
        }
        else if (data.total_price === data.total_paid) {
            return (
                <strong style={{ color: "green" }}>
                    خالص
                </strong>
            )
        }
        else {
            return (
                <strong style={{ color: "red" }}>
                    مدفوع جزاء
                </strong>
            )

        }
    }
    const footerDay = <>
        <table className="table table-bordered table-striped no-margin table-invoice" style={{ fontSize: "17px" }}>
            <thead className="color-view bg- ">
                <tr >
                    <th style={{ fontSize: "16px" }}>إجمالي الفواتير</th>
                    <th style={{ fontSize: "16px" }}>إجمالي الأشخاص</th>
                    {
                        filtered_data?.payment_types?.map(item => {
                            return (
                                <th style={{ fontSize: "16px" }}>
                                    {item.name_payment_type}
                                </th>
                            )
                        })
                    }
                </tr>
                <tr>
                    <td>{filtered_data?.payments?.length}</td>
                    <td>{filtered_data?.payments?.reduce((acc, item) => acc + (item?.number_people || 0), 0)}</td>
                    {
                        filtered_data?.payment_types?.map(item => {
                            return (
                                <td style={item.total_amount < 0 ? { fontSize: "16px", color: "red" } : item.total_amount > 0 ? { fontSize: "16px", color: "green" } : { fontSize: "16px" }}>
                                    {Intl.NumberFormat("en-US").format(item.total_amount)} د.ل
                                </td>
                            )
                        })
                    }
                </tr>
            </thead>
        </table>
        <div className="col-md-12" dir="ltr">
            <Button dir='ltr' type="button" label=" طبــاعة " icon='fa fa-file' outlined
                onClick={e => setPrintInvoicePayments_Day(true)}
            />
        </div>
    </>
    useEffect(() => {
        GetApartment();
        GetServices();
        GetPaymentType();
        GetUsers();
        GetBankAccounts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const scrollStyle = {
        overflowY: "auto",
        scrollbarWidth: "thin", // للمتصفحات غير Chrome

    };
    const scrollBarCSS = `
    ::-webkit-scrollbar {
            display: block !important;
            width: 5px;
            height: 8px;
        }
    `;
    return (
        <div className="page-wrapper" dir="rtl" >
            <div className="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />

                <div className="page-heading">
                    <h1 className="page-title"> كشف حساب المصرف - تحويلات مصرفية </h1>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a href="index.html"><i className="la la-home font-20"></i></a>
                        </li>
                    </ol>
                </div>
                <div className="card p-3">
                    <div className="col-md-12" style={{ fontFamily: "Cairo" }}>
                        <div className="row">
                            <div className="col-md-2">
                                <label id="lday"> مــن تـــاريخ </label>
                                <Calendar value={date_from}
                                    className="col-md-12"
                                    showButtonBar
                                    onChange={(e) => set_date_from(e.target.value)}
                                    dateFormat="yy-mm-dd"
                                    style={{ padding: "0", fontFamily: "Cairo" }}
                                    panelStyle={{ fontFamily: "Cairo", width: "30%" }}
                                    locale="ar"
                                />
                            </div>

                            <div className="col-md-2">
                                <label id="lday"> إلــى تـــاريخ </label>
                                <Calendar value={date_to}
                                    className="col-md-12"
                                    showButtonBar
                                    onChange={(e) => set_date_to(e.target.value)}
                                    dateFormat="yy-mm-dd"
                                    style={{ padding: "0", fontFamily: "Cairo" }}
                                    panelStyle={{ fontFamily: "Cairo", width: "30%" }}
                                    locale="ar"
                                />
                            </div>

                            <div className="col-md-2">
                                <label id="lday"> كشف حساب المصرف </label>
                                <MultiSelect className="col-md-12"
                                    options={bank_accounts}
                                    value={bank_accounts_view}
                                    itemTemplate={BankAccountsViewItemTemplate}
                                    onChange={(e) => set_bank_accounts_view(e.target.value)}
                                    optionLabel="value_key_2"
                                    display="chip"
                                    placeholder="اختار الحساب البنكي"
                                    emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                    maxSelectedLabels={3}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%", padding: "0", }}
                                    loading={loading_bank_accounts}
                                />
                            </div>

                            <div className="col-md-2">
                                <label id="lday"> نـــوع الخدمة </label>
                                <MultiSelect className="col-md-12"
                                    options={services}
                                    value={services_view}
                                    itemTemplate={ServicesViewItemTemplate}
                                    onChange={(e) => setServices_view(e.target.value)}
                                    optionLabel="service_name_ar"
                                    display="chip"
                                    placeholder="اختار مكان الاقامة"
                                    emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                    maxSelectedLabels={3}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%", padding: "0", }}
                                    loading={loading_apartment}
                                />
                            </div>

                            <div className="col-md-2">
                                <label id="lday"> نـــوع الإقــامة </label>
                                <MultiSelect className="col-md-12"
                                    options={apartments}
                                    value={apartments_view}
                                    itemTemplate={ApartmentsViewItemTemplate}
                                    onChange={(e) => setApartments_view(e.target.value)}
                                    optionLabel="number"
                                    display="chip"
                                    placeholder="اختار مكان الاقامة"
                                    emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                    maxSelectedLabels={3}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%", padding: "0", }}
                                    loading={loading_apartment}
                                />
                            </div>
                            <div className="col-md-2">
                                <label id="lday">المستخــدمين</label>
                                <MultiSelect className="col-md-12"
                                    options={users}
                                    value={users_view}
                                    itemTemplate={UsersViewItemTemplate}
                                    onChange={(e) => set_users_view(e.target.value)}
                                    optionLabel="name"
                                    display="chip"
                                    placeholder="اختار المستخدمين"
                                    emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                    maxSelectedLabels={3}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }}
                                    loading={loading_users}
                                />
                            </div>

                            <div className="col-md-1" >
                                <Button
                                    dir='ltr'
                                    type="button"
                                    icon="pi pi-search"
                                    label="عرض"
                                    outlined
                                    onClick={GetPaymentsDay}
                                    loading={loading_report_day}
                                    disabled={loading_users || loading_apartment ? true : false}
                                    style={{ fontFamily: "Cairo", marginTop: "30PX", display: "inline" }}
                                />
                            </div>
                        </div>
                    </div>
                    <br></br>
                    <style>{scrollBarCSS}</style>
                    {
                        loading_report_day ?
                            <DataTable value={items} className="p-datatable-striped" tableStyle={{ minWidth: '50rem' }} style={{ fontFamily: "Cairo", direction: "rtl" }}>
                                <Column field="date_payment" header="تاريخ الفاتورة" sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                {/* <Column field="ID_payment" header="الفاتورة"  style={{ width: '1%',textAlign:"right" }}></Column> */}
                                <Column field="ID_reservation" header="الحجز" style={{ width: '2%', textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="visitor_name" header="العميل" style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="number" header="نوع الإقامة" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column>
                                {/* <Column header="عدد الأشخاص" style={{ width: '2%', textAlign: "right" }} body={<Skeleton />}></Column> */}
                                {/* <Column header="عدد الأيام" style={{ width: '2%', textAlign: "right" }} body={<Skeleton />}></Column> */}
                                <Column field="total_price" header="السعر الكلي" style={{ width: '2%', textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="operation_type" header="نوع العملية" style={{ width: '2%', textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="amount" header="المبلغ" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="name_payment_type" header="نوع الدفع" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column header="حالة الحجز" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="name_user" header="المستخدم" style={{ width: '2%', textAlign: "right" }} body={<Skeleton />}></Column>
                            </DataTable>
                            :
                            <DataTable value={filtered_data?.payments} loading={loading_report_day}
                                dataKey="ID_payment"
                                selection={selectedpayments} onSelectionChange={(e) => setSelectedpayments(e.value)}
                                metaKeySelection={false} dragSelection
                                stripedRows showGridlines
                                footer={footerDay}
                                scrollable scrollHeight="700px"
                                emptyMessage={<center><img src={empty} alt="empty" width={"10%"} className='m-4'></img><h3>لايــوجد مدفــوعات</h3></center>}
                                tableStyle={scrollStyle}
                                style={{ fontFamily: "Cairo", direction: "rtl" }}
                            >
                                <Column field="date_payment" header="تاريخ الفاتورة" body={View_Date} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                <Column field="ID_payment" header="رقم الفاتورة" style={{ width: '1%', textAlign: "right" }}></Column>
                                <Column field="visitor_name" header="العميل" style={{ width: '5%', textAlign: "right" }}></Column>
                                <Column field="ID_reservation" header="الحجز" style={{ width: '2%', textAlign: "right" }}></Column>
                                <Column field="number" header="نوع الإقامة" body={view_Apartment} style={{ width: '1%', textAlign: "right" }}></Column>
                                {/* <Column field="date_check_in" body={(item) => {
                                    return <>
                                        {item?.date_check_in}
                                        {item?.date_check_out != item?.date_check_in ? <><br></br>{item?.date_check_out}</> : null}
                                    </>
                                }} header="تاريخ الحجز" style={{ width: '2%', textAlign: "right" }}></Column> */}
                                {/* <Column field="number_people" body={view_number_people} header="عدد الأشخاص" style={{ width: '1%', textAlign: "right" }}></Column> */}
                                {/* <Column header="عدد الأيام" body={View_Days} style={{ width: '1%', textAlign: "right" }}></Column> */}
                                <Column field="total_price" header="السعر الكلي" body={View_total_price} style={{ width: '2%', textAlign: "right" }}></Column>
                                <Column field="operation_type" header="نوع العملية" style={{ width: '1%', textAlign: "right" }}></Column>
                                <Column field="amount" header="المبلغ" body={View_Amount} style={{ width: '1%', textAlign: "right" }}></Column>
                                <Column field="name_payment_type" header="نوع الدفع" body={View_payment_type} style={{ width: '5%', textAlign: "right" }}></Column>
                                {/* <Column  header="حالة الحجز" body={state_res}  style={{ width: '1%',textAlign:"right" }}></Column> */}
                                <Column field="name_user" header="المستخدم" style={{ width: '2%', textAlign: "right" }}></Column>
                            </DataTable>
                    }
                </div>
                {
                    PrintInvoicePayments_Day ?
                        (
                            <>
                                <Dialog dir="rtl" header="مدفوعات " visible={PrintInvoicePayments_Day} maximizable style={{ width: '50vw', fontFamily: "Cairo" }}
                                    onHide={() => setPrintInvoicePayments_Day(false)} maximized={window.innerWidth <= 1230 ? true : false}
                                    footer={
                                        <div className="text-center">
                                            <ReactToPrint
                                                trigger={
                                                    () => <Button dir='ltr' type="button" label=" طبــاعة " icon='fa fa-print' outlined
                                                        ref={buttonRef} onClick={(e) => setIsShown(current => !current)}
                                                    />
                                                }
                                                content={() => componentRef.current}
                                                maximized={true}
                                            />
                                        </div>
                                    }
                                >
                                    <InvoiceContext.Provider value={filtered_data}   >
                                        {PrintInvoicePayments_Day && <div ref={componentRef}>  <InvoicePaymentsDates
                                            date_from={date_from}
                                            date_to={date_to}
                                        /></div>}
                                    </InvoiceContext.Provider>
                                </Dialog>
                            </>

                        )
                        :
                        (null)
                }
            </div>
        </div>
    )
}

export default PaymentsViaBankTransfers


